import { SyncEngine } from '@/sync/SyncEngine'

const engine = new SyncEngine()
engine.init()

export default {
  record: engine.record.bind(engine),
  playRemote: engine.playRemote.bind(engine),
  resync: engine.resync.bind(engine),
  observeEnd: engine.observeEnd.bind(engine),
  isSendingEvents: engine.isSendingEvents.bind(engine),
  isInitialized: engine.isInitialized.bind(engine),
  hasEvent: engine.hasEvent.bind(engine)
}
